import React from 'react';
import PropTypes from 'prop-types';

import './styles.scss';

export function TableCellLegendOverlay({ color }) {
  return (
    <div className="table-cell-overlay">
      <div className="legend-square" style={{ backgroundColor: color }}></div>
    </div>
  );
}

TableCellLegendOverlay.propTypes = {
  color: PropTypes.string,
};

export default TableCellLegendOverlay;
